const handler = response => {
    if (response.status >= 400) {
        let error = {
            status: response.status,
            description: response.statusText
        };
        throw new Error(JSON.stringify(error, null, 2));
    }
    return response;
};

export default handler;